import { render, staticRenderFns } from "./BaseEmptyData.vue?vue&type=template&id=47a97f93&"
import script from "./BaseEmptyData.vue?vue&type=script&lang=js&"
export * from "./BaseEmptyData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47a97f93')) {
      api.createRecord('47a97f93', component.options)
    } else {
      api.reload('47a97f93', component.options)
    }
    module.hot.accept("./BaseEmptyData.vue?vue&type=template&id=47a97f93&", function () {
      api.rerender('47a97f93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseEmptyData.vue"
export default component.exports